// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"deede380","350":"94e42c23","389":"13d44e01","590":"f3f692b1","627":"297646e6","787":"cf8164d9","788":"8e20356e","835":"aa7543be","838":"04de0039"}[chunkId] + ".chunk.js";
};